const formatDateISO = (date) => date.toISOString().split('T')[0];

const dataAtual = new Date();
const dataInicio = new Date();
dataInicio.setFullYear(dataAtual.getFullYear() - 1);

export default {
  distribuicaoTableHeaders: [
    {
      text: 'status',
      value: 'status',
      filterable: true,
      filterComponent: 'SetFilter',
      isDataTable: true,
      filterParams: {
        filterSet: [
          'PRÉ-EMBARQUE',
          'EM TRÂNSITO',
          'DESEMBARAÇO',
          'CARR/FATURAMENTO',
          'FECHAMENTO',
          'CONCLUÍDO',
        ],
        field: 'status',
      },
    },
    {
      text: 'referenciaTrust',
      value: 'referenciaTrust',
      width: 180,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'referenciaTrust',
      },
    },
    {
      text: 'marca',
      value: 'marca',
      width: 180,
      filterable: true,
      filterComponent: 'SetFilter',
      isDataTable: true,
      filterParams: {
        filterSet: [
          'DYMATIZE',
          'HI-TECH PHARMA',
          "LENNY''S LARRY",
          'MUSCLE TECH',
          'POWER CRUNCH',
          'QUEST NUTRITION',
          'RULE ONE',
        ],
        field: 'marca',
      },
    },
    {
      text: 'codigoProduto',
      value: 'codigoProduto',
      width: 180,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'codigoProduto',
      },
    },
    {
      text: 'descricaoProduto',
      value: 'descricaoProduto',
      width: 240,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'descricaoProduto',
      },
    },
    {
      text: 'estoqueAtual',
      value: 'estoqueAtual',
      width: 180,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'estoqueAtual',
      },
    },
    {
      text: 'quantidadeComprada',
      value: 'quantidadeComprada',
      width: 220,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'quantidadeComprada',
      },
    },
    {
      text: 'etd',
      value: 'etd',
      width: 180,
      filterable: true,
      filterComponent: 'DateFilter',
      isDataTable: true,
      filterParams: {
        field: 'etd',
      },
    },
    {
      text: 'eta',
      value: 'eta',
      width: 180,
      filterable: true,
      filterComponent: 'DateFilter',
      isDataTable: true,
      filterParams: {
        field: 'eta',
      },
    },
    {
      text: 'numeroInvoice',
      value: 'numeroInvoice',
      width: 180,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'numeroInvoice',
      },
    },
    {
      text: 'dataInvoice',
      value: 'dataInvoice',
      width: 180,
    },
    {
      text: 'valorInvoice',
      value: 'valorInvoice',
      width: 180,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'valorInvoice',
      },
    },
    {
      text: 'numeroPedidoCompra',
      value: 'numeroPedidoCompra',
      width: 260,
      tooltip: 'Conexos: Pedido de Compra (com043) - Cadastro - Código',
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'numeroPedidoCompra',
      },
    },
    {
      text: 'previsaoCambio',
      value: 'previsaoCambio',
      width: 180,
      tooltip: `Data inicio produção:
        - Adicionar 45 dias se a marca for DYMATIZE
        - Adicionar 60 dias se a marca for MUSCLE TECH
        - Adicionar 40 dias se a marca for QUEST NUTRITION
        - Adicionar 10 dias se a marca for HI-TECH PHARMA
        - Adicionar 10 dias se a marca for POWER CRUNCH
        - Adicionar 60 dias se a marca for RULE ONE
        - Adicionar 50 dias se a marca for LENNY'S LARRY`,
      filterable: true,
      filterComponent: 'DateFilter',
      isDataTable: true,
      filterParams: {
        field: 'previsaoCambio',
      },
    },
    {
      text: 'dataInicioProducao',
      value: 'dataInicioProducao',
      width: 240,
      tooltip: 'Conexos: Pedido de Compra (com043) - Follow Up - Inicio Produção',
      filterable: true,
      filterComponent: 'DateFilter',
      isDataTable: true,
      filterParams: {
        field: 'dataInicioProducao',
      },
    },
  ],
  distribuicaoTableItems: [],
  filtros: {
    termo: '',
    page: 1,
    perPage: 20,
    order: 'dataInvoice',
    direcao: 'DESC',

    visibilidade: 'todos',

    status: '',
    referenciaTrust: '',
    marca: '',
    codigoProduto: '',
    descricaoProduto: '',
    estoqueAtual: '',
    quantidadeComprada: '',
    etd: '',
    etdCondicao: '',
    eta: '',
    etaCondicao: '',
    numeroInvoice: '',
    dataInvoice: [formatDateISO(dataInicio), formatDateISO(dataAtual)],
    valorInvoice: '',
    previsaoCambio: '',
  },
  marcas: [
    {
      title: 'DYMATIZE',
      icon: 'DymatizeIcon',
      iconDark: 'DymatizeDarkIcon',
      value: '00.000.000,00',
    },
    {
      title: 'MUSCLE TECH',
      icon: 'MuscleTechIcon',
      iconDark: 'MuscleTechDarkIcon',
      value: '00.000.000,00',
    },
    {
      title: 'QUEST NUTRITION',
      icon: 'QuestNutritionIcon',
      iconDark: 'QuestNutritionDarkIcon',
      value: '00.000.000,00',
    },
    {
      title: 'HI-TECH PHARMA',
      icon: 'HiTechPharmaIcon',
      iconDark: 'HiTechPharmaDarkIcon',
      value: '00.000.000,00',
    },
    {
      title: 'POWER CRUNCH',
      icon: 'PowerCrunchIcon',
      iconDark: 'PowerCrunchDarkIcon',
      value: '00.000.000,00',
    },
    {
      title: 'RULE ONE',
      icon: 'RuleOneIcon',
      iconDark: 'RuleOneDarkIcon',
      value: '00.000.000,00',
    },
    {
      title: "LENNY'S LARRY",
      icon: 'LennysAndLarryIcon',
      iconDark: 'LennysAndLarryDarkIcon',
      value: '00.000.000,00',
    },
  ],
};
